import { useState } from 'preact/hooks';
import './rateCalculator.css';
import type { RemoteConfiguration } from '@thesavingsgroup/remote-configuration/types/RemoteConfiguration';
import { Logger } from '@thesavingsgroup/logger/Logger';
import { useRateTable } from '../../hooks/useRateTable/useRateTable';
import Error from '../Error/Error';
import { RateTableInternalError } from '@thesavingsgroup/rate-table/RateTableInternalError';
import Form from '../Form/Form';
import OfferList from '../OfferList/OfferList';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const RateCalculator = ({
  configuration,
  logger = new Logger(),
}: {
  configuration: RemoteConfiguration;
  logger?: Logger;
}) => {
  const [showOffers, setShowOffers] = useState(false);
  const [submittedLoanType, setSubmittedLoanType] = useState('');

  const { error } = useRateTable();

  const { title, copy } = error || {};

  if (error instanceof RateTableInternalError) {
    return <Error title={title} copy={copy} />;
  }

  return (
    <div className="experience-container">
      <Header configuration={configuration} />

      <Form
        configuration={configuration}
        logger={logger}
        setShowOffers={setShowOffers}
        setSubmittedLoanType={setSubmittedLoanType}
      />

      <OfferList
        configuration={configuration}
        logger={logger}
        showOffers={showOffers}
        submittedLoanType={submittedLoanType}
      />

      <Footer configuration={configuration} />
    </div>
  );
};

export default RateCalculator;
